// eslint-disable-next-line import/no-anonymous-default-export
export default {
  loading: false,
  error: false,
  createCompanyStatus: { data: null },
  deleteDirectorShareholderStatus: { data: null },
  companiesListStatus: { data: null },
  getCompaniesStatus: { data: null },
  updateCompanyStatus: { data: null },
  getOutletStatus: { data: null },
  createOutletStatus: { data: null },
  getEquipmentStatus: { data: null },
  getAllTechnicianListStatus: { data: null },
  getSalesPersonListStatus: { data: null },
  getDocumnetListStatus: { data: null },
  companiesStaffStatus: { data: null },
};
